import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useEffect, useState } from "react";
import "../../css/residency/ManageResidency.css";
import "../../css/Manage.css";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import MeetingMemberApi from "../../api/meetingMemberApi";
import AlertPopup from "../../components/AlertPopup";

const ManageMeetingMember = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [refundId, setRefundId] = useState(0);
  const [alertValue, setAlertValue] = useState(false);
  const { page } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const downloadExcel = async () => {
    const Excel = require("exceljs");
    const workbook = new Excel.Workbook();
    workbook.addWorksheet("Sheet One");
    const sheetOne = workbook.getWorksheet("Sheet One");

    sheetOne.columns = [
      { header: "주문자명", key: "name", width: 40 },
      { header: "휴대전화", key: "phoneNumber", width: 40 },
      { header: "이메일", key: "email", width: 40 },
      { header: "결제", key: "payment", width: 40 },
    ];

    excel.forEach((item) => {
      sheetOne.addRow(item);
    });
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "모임 결제 관리.xlsx");
  };

  const [arr, setArr] = useState([]);
  const [excel, setExcel] = useState([]);

  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(0);
  const [pageIndex, setPageIndex] = useState([]);
  const [postsPerPage, setPostsPerPage] = useState(null);

  const onRefund = async (id) => {
    setIsOpen(true);
    setRefundId(id);
    // await MeetingMemberApi.postMeetingMemberRefund(id);
  };

  useEffect(() => {
    const del = async () => {
      try {
        if (refundId <= 0) {
          return;
        }
        await MeetingMemberApi.postMeetingMemberRefund(refundId);
        toast("승인되었습니다.");
        setAlertValue(false);
        GetResidencyList();
      } catch (error) {
        toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
      }
    };
    if (alertValue) {
      del();
    }
  }, [alertValue]);

  useEffect(() => {
    setSearchKeyword(
      searchParams.get("keyword") ? searchParams.get("keyword") : ""
    );
    setCurrentPage(Number(page));
    GetResidencyList();
  }, [currentPage, location]);

  const GetResidencyList = async () => {
    try {
      const list = (
        await MeetingMemberApi.getMeetingMember({
          page: currentPage,
          size: 10,
          keyword: searchParams.get("keyword"),
        })
      ).data.data;

      setData(list.content);
      setTotalCount(list.totalCount);
      setPostsPerPage(list.content.length);

      const count = Math.ceil(list.totalCount / list.content.length / 4);

      for (let i = 1; i <= count; i++) {
        if (currentPage / 4 <= i) {
          setStartIndex(4 * (i - 1));
          return;
        }
      }
    } catch (err) {
      console.log(err);

      switch (err.response?.status) {
        case 401:
          toast(
            <div>
              인증시간이 만료되었습니다. <br /> 다시 로그인해주세요.
            </div>
          );
          sessionStorage.clear();
          navigate("/admin/login");
          break;
        case 500:
          toast(
            `${
              err.response.data.message
                ? err.response.data.message
                : "서버에 문제가 있습니다. 잠시후 다시 시도해주세요."
            }`
          );
          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    let page = Math.ceil(totalCount / postsPerPage);
    let arr = [];
    for (var i = 1; i <= page; i++) {
      arr.push(i);
    }
    setPageIndex(arr);
  }, [totalCount]);

  return (
    <div className="Manage-container">
      <section className="Manage-contents Manage-contents-table">
        <span>모임 결제 관리</span>
        <div className="manage-table-container">
          <div className="Manage-residency-search-container">
            <div className="Manage-residency-search-number">
              <span>전체 갯수</span>
              <span>{totalCount}</span>
            </div>
            <div className="Manage-residency-search">
              <div style={{ position: "relative" }}>
                <input
                  className="table-search-input"
                  type="text"
                  placeholder="검색어를 입력하세요"
                  onChange={(e) => {
                    setSearchKeyword(e.target.value);
                  }}
                  value={searchKeyword}
                />
                <img
                  src="/img/search.svg"
                  alt=""
                  style={{
                    position: "absolute",
                    right: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigate(`/admin/residency/1?keyword=${searchKeyword}`);
                  }}
                />
              </div>
              <div>
                <a onClick={downloadExcel} className="cursorPointer">
                  <img src="\img\download.svg" />
                  <span>엑셀로 내보내기</span>
                </a>
              </div>
            </div>
          </div>
          <div className="Manage-table manage-table-residency">
            <table>
              <thead>
                <tr>
                  <th>
                    <input
                      className="cursorPointer all-check-input"
                      type="checkbox"
                      id={"check"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          let obj = [];
                          const temp = data.map((value) => value.id);
                          data.forEach((item) => {
                            obj.push({
                              name: item.name,
                              phoneNumber: item.phoneNumber,
                              email: item.email,
                              payment: item.payment,
                            });
                          });
                          setArr(temp);
                          setExcel(obj);
                        } else {
                          setArr([]);
                          setExcel([]);
                        }
                      }}
                    ></input>
                  </th>
                  <th>주문자명</th>
                  <th>휴대전화</th>
                  <th>이메일</th>
                  <th>결제</th>
                  <th>환불 요청</th>
                </tr>
              </thead>
              <tbody>
                {data.map((v) => {
                  return (
                    <tr key={v.id}>
                      <td>
                        <input
                          type="checkbox"
                          id={`"check${v.id}"`}
                          className="cursorPointer"
                          checked={arr.includes(v.id)}
                          onChange={(e) => {
                            let obj = {
                              name: v.name,
                              phoneNumber: v.phoneNumber,
                              email: v.email,
                              payment: v.payment,
                            };
                            let copyData = [...arr];
                            let copyExcel = [...excel];
                            if (e.target.checked) {
                              copyData.push(v.id);
                              copyExcel.push(obj);
                              setArr(copyData);
                              setExcel(copyExcel);
                            } else {
                              let arrTemp = copyData.filter(
                                (item) => item !== v.id
                              );
                              let excelTemp = copyExcel.filter(
                                (item) =>
                                  item !==
                                  copyExcel.find((e) => e.email === v.email)
                              );

                              setArr(arrTemp);
                              setExcel(excelTemp);
                            }
                          }}
                        ></input>
                        <label htmlFor={`"check${v.id}"`}></label>
                      </td>
                      <td>{v.name}</td>
                      <td>{v.phoneNumber}</td>
                      <td>{v.email}</td>
                      <td>{v.payment}</td>
                      <td>
                        {v.meetingMemberStatus === "CANCEL_REQUEST" ? (
                          <button onClick={() => onRefund(v.id)} type="button">
                            승인
                          </button>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="manage-table-pagenation-container">
              <div className="manage-table-pagenation">
                <a
                  onClick={() => {
                    if (currentPage <= 1) {
                      return;
                    } else {
                      navigate(
                        `/admin/meeting-member/${
                          currentPage - 1
                        }?keyword=${searchKeyword}`
                      );
                    }
                  }}
                >
                  <img src="\img\chevron-left.svg" />
                </a>
                {pageIndex
                  .slice(startIndex, startIndex + 4)
                  .map((item, index) => {
                    return (
                      <a
                        key={index}
                        className={
                          currentPage === item ? "pagenation-focus" : null
                        }
                        onClick={() => {
                          navigate(
                            `/admin/meeting-member/${item}?keyword=${searchKeyword}`
                          );
                        }}
                      >
                        {item}
                      </a>
                    );
                  })}
                <a
                  onClick={() => {
                    if (currentPage >= pageIndex.length) {
                      return;
                    } else {
                      navigate(
                        `/admin/meeting-member/${
                          currentPage + 1
                        }?keyword=${searchKeyword}`
                      );
                    }
                  }}
                >
                  <img src="\img\chevron-right.svg" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <AlertPopup
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          headerTitle={"환불 요청 승인"}
          content={"환불 요청을 승인하겠습니까?"}
          setAlertValue={setAlertValue}
          cancelTitle={"취소"}
          confirmTitle={"승인"}
        />
      </section>
    </div>
  );
};

export default ManageMeetingMember;
